import { put, select } from 'redux-saga/effects';
import { signalingPhoneUsersLeft } from 'features/sip/actions';
import { activeUserCountUpdated, selectToolbarUserCount } from 'features/toolbar/toolbarSlice';

export function* onSipUsersLeftForCountSaga(action: ReturnType<typeof signalingPhoneUsersLeft>) {
  const { users } = action.payload;

  const currentCount: number = yield select(selectToolbarUserCount);
  yield put(activeUserCountUpdated(currentCount - users.length));
}
